/** Synchronous UI forwarding keeps feedback at the actual clicked control. */
export interface ActionInvocationOrigin { x: number; y: number }
let forwardedOrigin: ActionInvocationOrigin | null = null;

export const actionInvocationOrigin = (element: HTMLElement): ActionInvocationOrigin => {
  if (forwardedOrigin) return forwardedOrigin;
  const rect = element.getBoundingClientRect();

  return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
};
export const withActionInvocationOrigin = (origin: ActionInvocationOrigin, invoke: () => void): void => {
  const previous = forwardedOrigin;

  forwardedOrigin = origin;
  try { invoke(); }
  finally { forwardedOrigin = previous; }
};
